import { createMuiTheme } from "@material-ui/core/styles";
const tema = require("./theme2.json");
export const theme = createMuiTheme(tema);

export default theme;
